import { gsap } from "gsap";
import { Graphics, filters } from "pixi.js";

import { AbstractSpine } from "../../../../abstracts/graphics/AbstractSpine";
import { ApocalypseSpineNames } from "../../../assetsLoader/ApocalypseAssetsNames";
import { symbolConfig } from "../../../config/ApocalypseConfig";
import { ApocalypseSymbol } from "../symbols/ApocalypseSymbol";

export class FsHighLocker extends AbstractSpine {
    public isTop: boolean;
    public reelId: number;
    public symbol: ApocalypseSymbol;
    private symbolMask: Graphics;
    private shadowLine: Graphics;

    constructor(reelId: number) {
        super(ApocalypseSpineNames.HIGH_LOCKER);

        this.reelId = reelId;
        this.isTop = reelId < 6;

        if (this.isTop) {
            this.y = -100;
            this.rotation = Math.PI;
        } else {
            this.y = 527;
        }

        this.symbolMask = new Graphics();
        this.symbolMask.name = `symbolMask`;
        this.symbolMask.beginFill(0xffffff);
        this.symbolMask.drawRoundedRect(0, 0, 206, 180, 6);
        this.symbolMask.endFill();

        this.symbolMask.beginFill(0xffffff);
        this.symbolMask.drawRoundedRect(0, 160, 206, 40, 10);
        this.symbolMask.endFill();
        this.symbolMask.x = -104;
        this.symbolMask.y = this.isTop ? -197 : -197;

        const blurFilter = new filters.BlurFilter();
        blurFilter.blurX = 0;
        blurFilter.blurY = 2;

        this.shadowLine = new Graphics();
        this.shadowLine.name = `shadowLine`;
        this.shadowLine.lineStyle(4, 0x000000, 1);
        this.shadowLine.moveTo(0, 0);
        this.shadowLine.lineTo(symbolConfig.symbolWidth, 0);
        this.shadowLine.filters = [blurFilter];

        this.setSkinByName(`M3`);
    }

    public enableMask(): void {
        this.addChild(this.symbolMask);
        this.symbol.mask = this.symbolMask;

        this.shadowLine.y = this.isTop ? 4 : symbolConfig.symbolHeight - 2.5;

        this.symbol.addChild(this.shadowLine);
    }

    public getWheelsAnimation(): gsap.core.Tween {
        return this.getSpineTween(
            `wheels_move_${this.isTop ? `left` : `right`}`,
            false,
            null,
            null,
            () => {
                this.state.setAnimation(0, `default`, false);
                // this.setSkinByName(`M3`);
            }
        );
    }

    public disableMask(): void {
        this.symbol.mask = null;
        this.removeChild(this.symbolMask);

        this.symbol.removeChild(this.shadowLine);
    }

    public destroy(options?: any) {
        this.symbolMask.destroy();
        this.shadowLine.destroy();

        super.destroy(options);
    }
}
